import React, { useEffect } from "react";
import Modal from "@components/_Revamp/Modal";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription/TitleAndDescription";
import Button from "@components/_Revamp/Button";
import { styled } from "@linaria/react";
import { isNull } from "lodash";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import { Text } from "../Text";
import { css } from "@linaria/core";
import error from "@assets/icon/triangle-error.svg";
import { SCREEN_SIZE } from "@static/screen-size";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  flex-direction: column;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    flex-direction: row;
    gap: 24px;
  }
`;

const ErrorContainer = styled.p`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: -40px;
  margin-bottom: 40px;
  padding: "0 10px";
  text-align: center;
  font-style: normal;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 500;
  color: #434343;

  span {
    font-weight: 600;
  }
`;

interface ErrorModal {
  onCloseFn?: () => void;
  onBackToQuote?: () => void;
}

const titleCss = css`
  white-space: break-spaces;
`;

function DateOfBirthModal({ onCloseFn, onBackToQuote }: ErrorModal) {
  const history = useHistory();
  const isErrorModal = onCloseFn ? false : true;

  return (
    <Modal show={true} isErrorModal={isErrorModal}>
      <div style={{ width: "100%", display: "flex" }}>
        <img src={error} alt="error" style={{ margin: "auto" }} />
      </div>
      <Text
        variant="title"
        align="center"
        margin={"0 0 60px 0"}
        textClass={titleCss}
      >
        Date of birth is not the same as Singpass
      </Text>

      <ErrorContainer>
        <div>
          The quote we provided earlier was based on the date of birth you
          entered.
        </div>
      </ErrorContainer>
      <ButtonContainer>
        <Button
          variant="secondary"
          label="Back to quote"
          width="180px"
          height="52px"
          onClick={onBackToQuote}
        />
      </ButtonContainer>
    </Modal>
  );
}

export default DateOfBirthModal;
